import React from "react";
import CancelIcon from "@mui/icons-material/Cancel";

function ViewCustomerModal({ isOpen, onClose, customer }) {
  if (!isOpen || !customer) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-semibold">Customer Details</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <CancelIcon className="cursor-pointer text-black" />
          </button>
        </div>

        <div className="flex flex-col gap-4">
          {/* Customer Information */}
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="font-semibold text-lg mb-3 text-gray-800">
              Customer Information
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <p className="text-sm text-gray-600 mb-1">Name</p>
                <p className="font-medium text-gray-900">
                  {customer?.name || "N/A"}
                </p>
              </div>
              {/* <div>
                <p className="text-sm text-gray-600 mb-1">Discount</p>
                <p className="font-medium text-gray-900">
                  {customer?.discount ? `${customer.discount}%` : "N/A"}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-600 mb-1">Email</p>
                <p className="font-medium text-gray-900">
                  {customer?.email || "N/A"}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-600 mb-1">Phone Number</p>
                <p className="font-medium text-gray-900">
                  {customer?.phone_number || "N/A"}
                </p>
              </div> */}
              <div className="md:col-span-2">
                <p className="text-sm text-gray-600 mb-1">
                  Email / Phone Number (Preference)
                </p>
                <p className="font-medium text-gray-900">
                  {customer?.preference || "N/A"}
                </p>
              </div>
            </div>
          </div>

          {/* Comments Section */}
          <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
            <h3 className="font-semibold text-lg mb-3 text-gray-800">
              Comments
            </h3>
            <div className="bg-white p-4 rounded border border-blue-100 min-h-[100px]">
              {customer?.comment ? (
                <p className="text-gray-800 whitespace-pre-wrap break-words">
                  {customer.comment}
                </p>
              ) : (
                <p className="text-gray-400 italic">No comments available</p>
              )}
            </div>
          </div>
        </div>

        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default ViewCustomerModal;
